import React from "react"
import autobind from "class-autobind"
import Dropzone from "react-dropzone"
import strings from "../../localization/strings"
import { grey200 } from "material-ui/styles/colors"
import { CircularProgress } from "material-ui"
import * as api from "../../api"
import { IFileDocument } from "../../models"
import * as fileActions from "../../actions/FileActions"
import AppStateStore from "../../stores/AppStateStore"
import * as utils from "../../helpers/utils"
interface IProps {
    onlyPdfImg?: boolean
    width?: number
    height?: number
    uploadAreaLabel?: string
    fileDocumentId: string
    handleChangeFileId?(fileDocumentId: string): void
    handleChangeFile?(file: IFileDocument): void
    handleChangeloadStatus?(loading: boolean): void
}
interface IState {
    fileDocument: IFileDocument
    file: File
}

export default class FileUpload extends React.Component<IProps, IState> {
    private areaStyle
    constructor(props) {
        super(props)
        this.areaStyle = {
            height: this.props.height ? this.props.height : 75,
            width: this.props.width ? this.props.width : 375,
            border: "dashed 1px #cccccc",
            fontSize: 15,
            textAlign: "center",
            backgroundColor: grey200,
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }

        this.state = {
            fileDocument: null,
            file: null
        }
        autobind(this)
    }

    componentDidMount() {
        this.props.fileDocumentId &&
            api.getFile(this.props.fileDocumentId).then(res => this.setState({ fileDocument: res.data }))
    }

    handleUpload(file) {
        if (!utils.validateUploadFileExtension(file, this.props.onlyPdfImg ? this.props.onlyPdfImg : false, false)) {
            AppStateStore.setAlertDialogContent({
                title: strings.This_file_format_is_not_supported,
                content: strings.Supported_file_types + (this.props.onlyPdfImg ? ": .pdf, .png, .jpg" : ": .jpg, .jpeg, .png, .bmp, .pdf, .zip, .txt, .html, .doc, .docx, .csv, .xlsx, .xls, .pptx, .ppt")
            })
        }
        else if (!utils.validateFileSize(file)) {
            AppStateStore.setAlertDialogContent({
                title: strings.This_file_size_is_too_large,
                content: strings.Maximum_File_Size + ": 10 MB"
            })
        }
        else {
            this.setState({ file })
            this.props.handleChangeloadStatus(true)
            fileActions.uploadFile(file)
                .then(fileDocument => {
                    this.props.handleChangeloadStatus(false)
                    this.setState({ fileDocument })
                    fileDocument === null &&
                        this.setState({ file: null })
                    this.props.handleChangeFileId &&
                        this.props.handleChangeFileId(fileDocument ? fileDocument.Id : null)
                    this.props.handleChangeFile &&
                        this.props.handleChangeFile(fileDocument ? fileDocument : null)
                })
        }
    }

    render() {
        return (this.state.fileDocument || this.state.file) ?
            <div data-intercom-target={"OpenFileUploadSelection"} style={this.areaStyle}>
                {this.state.file && !this.state.fileDocument ?
                    <CircularProgress /> :
                    <div>
                        <div
                            className="TextOverflow"
                            style={{ width: this.props.width ? this.props.width - 75 : 300 }}
                        >
                            {this.state.fileDocument.Name}
                        </div>
                        <div style={{ position: "absolute", right: 4, top: 0 }}>
                            <i
                                data-intercom-target={"Btn-RemoveUploadedFile"}
                                className="fa fa-remove"
                                style={{ fontSize: 15 }}
                                onClick={() =>
                                    AppStateStore.setConfirmDialogContent({
                                        content: strings.Are_you_sure_want_to_remove_the_uploaded_file,
                                        confirm: () => {
                                            this.props.handleChangeloadStatus(true)
                                            fileActions.removeUploadedFile(this.state.fileDocument.Id).then(() => {
                                                this.props.handleChangeloadStatus(false)
                                                this.setState({
                                                    file: null,
                                                    fileDocument: null
                                                })
                                                this.props.handleChangeFileId &&
                                                    this.props.handleChangeFileId(null)
                                                this.props.handleChangeFile &&
                                                    this.props.handleChangeFile(null)
                                            })
                                        }
                                    })
                                }
                            />
                        </div>
                        <div style={{ position: "absolute", right: 15, top: 25 }}>
                            <i
                                className="fa fa-download"
                                style={{ fontSize: 27 }}
                                onClick={() => fileActions.downloadFile(this.state.fileDocument)}
                            />
                        </div>
                    </div>
                }
            </div> :
            <Dropzone
                data-intercom-target={"OpenFileUploadSelection"}
                onDrop={files => this.handleUpload(files[0])}
                style={this.areaStyle}
                activeStyle={{
                    border: "dashed 1px #666666",
                    background: "#e7e7e7"
                }}
            >
                <span style={{ whiteSpace: "pre-line" }}>{this.props.uploadAreaLabel ? this.props.uploadAreaLabel : strings.Drag_and_Drop_or_click_to_choose_a_file}</span>
                <div style={{ position: "absolute", right: 15 }}>
                    <i className="fa fa-upload" style={{ fontSize: 27 }} />
                </div>
            </Dropzone>
    }
}
